exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell-item[data-v-9218f214]{padding-right:0.05208rem;padding-bottom:0.03125rem;padding-left:0.05208rem}.cell-item+.cell-item[data-v-9218f214]{padding-top:0.03125rem;padding-bottom:0;border-top:0.00521rem solid #E8E8E8}[data-v-9218f214] .el-table--mini th,[data-v-9218f214] .el-table--mini td{border-bottom:0.00521rem solid #E8E8E8 !important}\n", ""]);

// exports
